import {MOBILE_BREAKPOINT_WITH_PADDING_PX} from '@/components/assistant/constants'
import {useBreakpoints} from '@vueuse/core'

export function useAssistantViewport() {
  const breakpoints = useBreakpoints({
    mobile: MOBILE_BREAKPOINT_WITH_PADDING_PX,
  })

  return {
    isMobileVersion: breakpoints.smaller('mobile'),
    isDesktopVersion: breakpoints.greaterOrEqual('mobile'),
  }
}
